import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { catchError, concatMap, tap } from "rxjs/operators";
import { EMPTY, merge, Subscription } from "rxjs";
import { AWSHttpClient } from "@intocare-medapp/aws/http";
import { ApplicationState } from "../shared/state/state/application.state";
import { IotModel } from "../shared/models/iot.model";
import { DarCreatedTopic, DarTopicNames } from "../shared/models/iot.topics";
import { DarItem } from "../shared/types";
import { DarActions, PubsubModel } from "../shared";

@Injectable()
export class DarListener extends PubsubModel {
	private readonly store = inject<Store<ApplicationState>>(Store);
	private readonly iotModel = inject(IotModel);
	private readonly http = inject(AWSHttpClient);

	listen(): Subscription {
		return merge(this.syncCreateDar(), this.syncUpdateDar()).subscribe();
	}

	getDarFromHttp(id: string) {
		return this.http.get<DarItem>(`dars/${id}`).pipe(
			catchError(() => {
				return EMPTY;
			}),
		);
	}

	syncCreateDar() {
		return this.iotModel.subscribeWithOrganisationPrefix<DarCreatedTopic>(DarTopicNames.DAR_CREATED).pipe(
			concatMap((topicData) => this.getDarFromHttp(topicData.darId)),
			tap((dar) => {
				this.store.dispatch(DarActions.addDar(dar));
			}),
		);
	}

	syncUpdateDar() {
		return this.iotModel.subscribeWithOrganisationPrefix<DarCreatedTopic>(DarTopicNames.DAR_UPDATED).pipe(
			concatMap((topicData) => this.getDarFromHttp(topicData.darId)),
			tap((dar) => {
				this.store.dispatch(DarActions.updateDar(dar));
			}),
		);
	}
}
